import { ModelMetier } from './../../providers/model-metier';
import { MyFirebaseList } from './../../providers/my-firebase-list';
import { MyFirebase } from './../../providers/my-firebase';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Page list all cloud, select a cloud, display all licId attached to this cloud.
 * Can print list ?, export list ?
 */
@IonicPage()
@Component({
  selector: 'page-info-cloud-detail',
  templateUrl: 'info-cloud-detail.html',
})
export class InfoCloudDetailPage {

  // Parent page, passed by navParams.get('parent')
  parentPage : any;

  // The Element to edit, can be null in creation, passed by navParams.get('ele')
  ele : any;

  // The Element Id in edit, can be null in creation, passed by navParams.get('eleId')
  eleId : any;


  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.parentPage = this.navParams.get('parent');
    this.eleId = this.navParams.get('eleId');
    this.ele = Object.assign({}, this.navParams.get('ele') );  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoCloudDetailPage');
  }



}

/*
TODO

  Question ?
    utiliser ele avec ele.licIds a afficher en list
    ou
    recherger /clouds/{cloudId}/licIds

    ==> semble ne pas faire le rafraichissement, comme est charger dans autre page (autre zone) ?



 Can print list ?, export list ?

  dans Fb /clouds/{cloudId}/name
  et  /clouds/{cloudId}/licIds/{licId}

*/



// WEBPACK FOOTER //
// ./src/pages/info-cloud-detail/info-cloud-detail.ts